var Faqs = (function (window, document, undefined) {

  'use strict';

  // quick search regex
  var qsRegex;
  var $grid;
  var $quicksearch;
  var isoOptions = {
    itemSelector: '.contenedor-faqs__item:not(.no-resultados)',
    columnWidth: '.contenedor-faqs__item-sizer',
    percentPosition: true,
    gutter: 16,
    filter: function () {
      return qsRegex ? $(this).text().match(qsRegex) : true;
    }
  };

  var init = function () {
    initializeQuicksearch();
    manageBindings();

    $(window).resize(function () {
      manageBindings();
    });
  };

  // init Quicksearch
  var initializeQuicksearch = function () {
    $grid = $('.contenedor-faqs').isotope(isoOptions);

    // use value of search field to filter
    $quicksearch = $('.quicksearch').keyup(debounce(function () {
      qsRegex = new RegExp($quicksearch.val(), 'gi');
      $grid.isotope();
      $('.collapsible-header h2 span').html($quicksearch.val());
      var visibleItemsCount = $grid.data('isotope').filteredItems.length;
      if (visibleItemsCount > 0) {
        $('.no-resultados').hide();
      } else {
        $('.no-resultados').show();
      }
    }, 200));

    // debounce so filtering doesn't happen every millisecond
    function debounce(fn, threshold) {
      var timeout;
      return function debounced() {
        if (timeout) {
          clearTimeout(timeout);
        }

        function delayed() {
          fn();
          timeout = null;
        }
        timeout = setTimeout(delayed, threshold || 100);
      };
    }
  };

  var manageBindings = function () {
    NG.X = Utilities.updateWidth();

    if (NG.X >= NG.tabletWidthPortrait) {
      $('.collapsible-header a').attr('aria-expanded', true);
      $('.contenedor-faqs__item a').removeAttr('data-toggle').on('click', function (e) {
        e.preventDefault();
      });
      $('.contenedor-faqs__item').removeClass('autoheight');
      $(".contenedor-faqs").removeClass('autoheight');

      $grid.isotope();
    } else {
      $('.collapsible-header a').attr('aria-expanded', false);
      $('.contenedor-faqs__item a').attr('data-toggle', 'collapse');

      // $('.collapsible-body').on('shown.bs.collapse', function (e) {
      //   console.log('show', e);
      //   $grid.isotope();
      // });
      // $('.collapsible-body').on('hidden .bs.collapse', function (e) {
      //   console.log('hide', e);
      //   $grid.isotope();
      // });

      $('.contenedor-faqs__item').addClass('autoheight');
      $(".contenedor-faqs").addClass('autoheight');
    }

    if (NG.X >= NG.tabletWidthLandscape && NG.X <= NG.desktopWidthSmall) {
       $(".buscador-faqs__input-buscar input").attr("placeholder", "Introduzca su búsqueda");
    }
    else {
      $(".buscador-faqs__input-buscar input").attr("placeholder", "Introduzca su búsqueda");
    }
  };


  return {
    init: init
  };

}(window, document));



// WEBPACK FOOTER //
// src/assets/js/faqs.js